import { createTheme } from '@mui/material'

export const { palette } = createTheme({
  palette: {
    primary: {
      main: '#003F7D',
      dark: '#003263',
      light: '#004F9E',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#E5F2FF',
      dark: '#A8D3FF',
      light: '#E5F2FF',
      contrastText: '#003263',
    },
    error: {
      main: '#871919',
      dark: '#520F0F',
      light: '#FFE7E7',
      contrastText: '#FFFFFF',
    },
    warning: {
      main: '#5F3D16',
      dark: '#2E1D0B',
      light: '#FFF3C9',
      contrastText: '#FFFFFF',
    },
    info: {
      main: '#003F7E',
      dark: '#003263',
      light: '#004F9E',
      contrastText: '#FFFFFF',
    },
    success: {
      main: '#0F4D14',
      dark: '#0F4D14',
      light: '#E8F5E9',
      contrastText: '#FFFFFF',
    },
    text: {
      primary: 'rgba(0, 0, 0, 0.87)',
      secondary: 'rgba(0, 0, 0, 0.60)',
      disabled: 'rgba(0, 0, 0, 0.38)',
    },
    background: {
      default: '#FAF8F5',
      // secondary: '#FFFFFF',
      // tertiary: '#F0EEEB'
    },
    /* Migrated from the app; not BS 2.0 */
    common: {
      black: '#212529',
      white: '#FFFFFF',
    },
  },
})

export const colors = {
  ...palette,
  background: {
    primaryBackground: '#F6F8FA',
    secondaryBackground: '#FFFFFF',
    tertiaryBackground: '#F0EEEB',
    dialogBackground: 'rgba(26, 26, 26, 0.5)',
    navigation: '#003F7D',
    navigationHover: '#2A6CAC',
    navigationActive: '#E8F3FF',
    ...palette.background,
  },
  copy: {
    headerDark: '#1A1A1A',
    headerLight: '#FFFFFF',
    paragraphDark: '#333333',
    paragraphLight: '#F2F2F2',
  },
  feedback: {
    successLight: '#E8F5E9',
    errorLight: '#FFE7E7',
    warningLight: '#FFF3C9',
    infoLight: '#E4EDF6',
    successDark: '#0F4D14',
    errorDark: '#871919',
    warningDark: '#5F3D16',
    infoDark: '#003263',
  },
  interactive: {
    primaryEnabled: '#003F7E',
    secondaryEnabled: '#E4EDF6',
    tertiaryEnabled: '#FAF8F5',
    primaryHoverFocus: '#003263',
    secondaryHoverFocus: '#EFF3F5',
    tertiaryHoverFocus: '#FFFFFF',
    disabledDark: '#4D4D4D',
    disabledLight: '#B2B2B2',
    tableHoverFocus: '#F5F5F5',
    borderEnabledHoverGray: '#E5E4E1',
    shadowHoverGray: '#F0EEEB',
    borderHoverLightBlue: '#48A3FD',
    shadowHoverLightBlue: '#75B8FB',
    borderFocusOrange: '#FEB947',
    shadowFocusOrange: '#FBE8C9',
    borderActiveLightBlue: '#1C83FF',
    shadowActiveLightBlue: '#48A3FD',
    borderActiveDarkBlue: '#003263',
    shadowActiveDarkBlue: '#C8D0D8',
  },
  accent: {
    lightBlue: '#1C8EFF',
    lightOrange: '#FFA91B',
    lightGreen: '#3ED865',
  },
  illustration: {
    darkBlue: '#003263',
    darkGreen: '#006319',
    darkOrange: '#633E00',
    gray10: '#1A1A1A',
    gray95: '#F2F2F2',
    gray100: '#FFFFFF',
    lightBlue10: '#E4EDF6',
    lightBlue80: '#48A3FD',
    lightGreen10: '#E7F5E7',
    lightGreen80: '#64DE82',
    lightOrange10: '#FAF0DF',
    lightOrange80: '#FEB947',
    skinTone1: '#704600',
    skinTone2: '#CD7A32',
    skinTone3: '#E6BC98',
  },
  customization: {
    shadeBerry: '#140062',
    shadeBrown: '#362000',
    shadeBurgundy: '#3D0000',
    shadeCobalt: '#002459',
    shadeForestGreen: '#232C00',
    shadeGreen: '#003415',
    shadeIndigo: '#430053',
    shadeMagenta: '#46002A',
    shadeTeal: '#003535',
  },
  visualization: {
    berry: '#2700C4',
    brown: '#6B4000',
    burgundy: '#7A0000',
    cobalt: '#0047B2',
    forestGreen: '#455700',
    green: '#005723',
    indigo: '#8500A6',
    magenta: '#8C0054',
    teal: '#005959',
    tintBerry: '#C6B9FA',
    tintBrown: '#E4D1B5',
    tintBurgundy: '#E7B6B6',
    tintCobalt: '#B7CFF4',
    tintForestGreen: '#D7DFB5',
    tintGreen: '#B5DFC6',
    tintIndigo: '#E5B6F2',
    tintMagenta: '#ECB5D6',
    tintTeal: '#B5E0E0',
  },
  content: {
    aiDark: '#1F183D',
    aiMedium: '#4D3D99',
    aiLight: '#DEDAF2',
  },
  components: {
    alert: {
      info: {
        background: '#E5F2FF',
        type: '#003F7E',
      },
    },
  },
}
